import React from "react";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import { useParams } from "react-router-dom";
import useDocumentById from "../../hooks/useDocumentById";
import BankTable from "../../components/Bank/table";
import getRequiredUserData from "../../utils/getBranchInfo";
import useUserClaims from "../../hooks/useUserClaims";
import { useAuth } from "../../contexts/AuthContext";
import { useState } from "react";
import { firestore } from "../../services/firebase";
import { collection, doc, where, query, onSnapshot } from "firebase/firestore";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { ExportToExcel } from "../../utils/ExportToExcel";
import BankAccountInformationForm from "../../components/Bank/create_Bank_Account_Information_Form";
import BankAccountInfoTable from "../../components/Bank/account_info_table";

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const flexItemStyle = {
  flex: 9,
};

const flexItemStyles = {
  flex: 1,
};

const BankAccountInformation = () => {
  const params = useParams();
  const theme = useTheme();
  const branchData = getRequiredUserData();
  let branchId = branchData.requiredId;
  const { documentData } = useDocumentById("Bank", params.id);
  const { user } = useAuth();
  const userClaims = useUserClaims(user);

  const [branch, setBranch] = useState({});
  const [bankAccounts, setBankAccounts] = useState([]);

  useEffect(() => {
    const getAccountInfo = query(
      collection(firestore, "BankAccountInformation"),
      where("branchId", "==", params.id ? params.id : branchId)
    );

    const unsubscribe = onSnapshot(getAccountInfo, (querySnapshot) => {
      const accounts = [];
      querySnapshot.forEach((doc) => {
        accounts.push({ id: doc.id, ...doc.data() });
      });
      setBankAccounts(accounts);
    });

    return () => unsubscribe();
  }, [params.id]);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Bank Account Information</title>
        {/* <link rel="canonical" href="http://localhost:3000/" /> */}
        <meta name="description" content="List of Bank Account Informations" />
      </Helmet>
      <Box
        m="1.5rem 2.5rem"
        sx={{
          backgroundColor: theme.palette.background.default,
          height: "100%",
          position: "relative",
        }}
      >
        <Grid container spacing={2}>
          <Grid
            item
            xs={userClaims.superAdmin ? 6 : 4}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <Box flex="1">
              <Typography
                variant="h2"
                color={theme.palette.secondary[100]}
                fontWeight="bold"
                sx={{ mb: "5px" }}
              >
                Bank Account Information
              </Typography>

              <Typography variant="h5" color={theme.palette.secondary[300]}>
                Entire list of Bank Account Informations
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={userClaims.superAdmin ? 6 : 5}
            sx={{
              display: "flex",
              justifyContent: userClaims.superAdmin ? "flex-end" : "center",
              alignItems: userClaims.superAdmin ? "flex-end" : "center",
            }}
          ></Grid>
          <Grid
            item
            xs={userClaims.superAdmin ? 0 : 3}
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <BankAccountInformationForm source="branches" />
          </Grid>
        </Grid>

        <div style={containerStyle}>
          <div style={flexItemStyle}></div>
          <div style={flexItemStyles}>
            {userClaims.superAdmin ? (
              <ExportToExcel
                file={"branches"}
                branchId={branchData.requiredId}
                id={""}
                endpoint={"bank"}
                clear={true}
                name={`BankTable-Branch ${branchData.branchName}`}
              />
            ) : null}
          </div>
        </div>

        <Grid container spacing={2} marginTop={"10px"}>
          {bankAccounts.map((account, index) => (
            <Grid item xs={6} key={account.id}>
              <Typography variant="h6" fontWeight="bold" fontSize={"24px"}>
                {account.bankName}
              </Typography>
              <BankAccountInfoTable bank={account} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default BankAccountInformation;
